// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3904A","text":"SelectPayment_text__2jMaW","title":"SelectPayment_title__3eB_g","btn":"SelectPayment_btn__E3Xkd"};